(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-markenreise"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FAMILY_LABELS = {
      wind_weite: 'Wind & Weite',
      dranbleiben: 'Dranbleiben',
      standfest: 'Standfest',
      technik: 'Technik & Kontrolle',
      dunkel: 'Klare Kante',
      alte_schule: 'Alte Schule',
      ring_stil: 'Ring & Stil',
      eigener_weg: 'Eigener Weg',
      crew: 'Zusammen stehen',
      leise_klar: 'Leise & klar'
    };

    const FAMILY_REASON = {
      wind_weite: 'Wind, Wasser, Weite. Das ist bei deiner Auswahl mehr als Kulisse.',
      dranbleiben: 'Bei dir zählt der nächste Schritt mehr als der einfache Weg.',
      standfest: 'Bei dir geht es um Haltung, Beständigkeit und darum, wieder aufzustehen.',
      technik: 'Ruhe, Kontrolle, sauberes Handwerk. Das passt zu deiner Auswahl.',
      dunkel: 'Klare Aussage, klare Kante. Nicht laut um jeden Preis.',
      alte_schule: 'Klassischer Boxsport, Handwerk, wenig Schnickschnack.',
      ring_stil: 'Boxkultur darf sichtbar sein. Aber sie muss tragbar bleiben.',
      eigener_weg: 'Du willst deinen Weg nicht groß erklären müssen. Das zieht sich durch deine Auswahl.',
      crew: 'Bei dir zählt nicht nur der Einzelne. Die Menschen neben dir gehören dazu.',
      leise_klar: 'Leise, klar, ohne großes Gerede. Das liegt dir näher.'
    };

    const FAMILY_KEYWORDS = {
      wind_weite: {
        strong: ['54° nord', '54 grad', 'förde', 'foerde', 'küste', 'kueste', 'wind', 'wasser', 'weite', 'heimat', 'hafen', 'norden', 'maritim'],
        weak: ['draußen', 'draussen', 'freiheit', 'weg', 'kiel']
      },
      dranbleiben: {
        strong: ['fleiß', 'fleiss', 'wiederholung', 'dranbleiben', 'weitermachen', 'fortschritt', 'train harder', 'eat sleep repeat', 'aufgeben ist keine option', 'einheit für einheit', 'tag für tag'],
        weak: ['training', 'arbeiten', 'disziplin', 'halle', 'gym']
      },
      standfest: {
        strong: ['rückgrat', 'rueckgrat', 'standhalten', 'widerstand', 'wiederkommen', 'niederlage', 'rückschlag', 'rueckschlag', 'unbeugsam', 'kein rückzug', 'kein rueckzug', 'durchhalten', 'unzerbrechlich'],
        weak: ['haltung', 'kämpfen', 'kaempfen', 'stärke', 'staerke', 'disziplin']
      },
      technik: {
        strong: ['technik', 'kontrolle', 'timing', 'präzision', 'praezision', 'atmung', 'grundlagen', 'handwerk', 'fokus', 'wahrnehmung', 'geduld'],
        weak: ['training', 'disziplin', 'boxhalle', 'lernen']
      },
      dunkel: {
        strong: ['berserker', 'skull', 'widerstand', 'unbeugsam', 'kompromisslos', 'roh', 'dunkel', 'kante'],
        weak: ['stark', 'direkt', 'hart']
      },
      alte_schule: {
        strong: ['faustkampf', 'pugilist', 'old school', 'alte schule', 'tradition', 'klassischer boxsport', 'handwerk'],
        weak: ['klassisch', 'ring', 'grundlagen', 'boxgeschichte']
      },
      ring_stil: {
        strong: ['ring ruler', 'king of the ring', 'boxing dream', 'boxing strength', 'förde nights', 'foerde nights', 'ringkultur', 'streetwear'],
        weak: ['ring', 'style', 'look', 'boxkultur', 'boxing']
      },
      eigener_weg: {
        strong: ['für dich', 'fuer dich', 'eigener weg', 'selbst entscheiden', 'seele', 'fight for your soul', 'sometimes princess', 'kämpferin', 'kaempferin', 'boxing angel', 'selbstbestimmung'],
        weak: ['haltung', 'freiheit', 'stärke', 'staerke', 'motivation']
      },
      crew: {
        strong: ['boxing crew', 'crew', 'zusammenhalt', 'gemeinsam', 'füreinander', 'fuereinander', 'verlässlichkeit', 'verlaesslichkeit', 'menschen neben dir', 'seite an seite', 'tragwerk'],
        weak: ['team', 'halle', 'gemeinsame zeit', 'training']
      },
      leise_klar: {
        strong: ['reduziert', 'ruhig', 'kein großes gerede', 'kein grosses gerede', 'keine show', 'leise', 'klar', 'ohne erklärung', 'ohne erklaerung', 'zurückhaltend', 'zurueckhaltend', 'minimal'],
        weak: ['einseitig', 'klein', 'schlicht', 'dezent']
      }
    };

    const KNOWN_DESIGNS = [
      { id: 'black_demut', label: 'Black Edition – Demut', patterns: ['black edition demut', 'demut'], weights: { leise_klar: 100, technik: 70, alte_schule: 45 }, reason: 'Ruhige Haltung. Kontrolle, Respekt, kein großes Theater.' },
      { id: 'black_widerstand', label: 'Black Edition – Widerstand', patterns: ['black edition widerstand'], weights: { standfest: 100, dunkel: 75, leise_klar: 55 }, reason: 'Gegenhalten, ohne Krawall daraus zu machen.' },
      { id: 'black_unbeugsam', label: 'Black Edition – Unbeugsam', patterns: ['black edition unbeugsam', 'unbeugsam'], weights: { standfest: 100, dunkel: 75, eigener_weg: 55 }, reason: 'Bei sich bleiben. Auch wenn es Gegenwind gibt.' },
      { id: 'black_unzerbrechlich', label: 'Black Edition – Unzerbrechlich', patterns: ['black edition unzerbrechlich', 'unzerbrechlich'], weights: { standfest: 100, dunkel: 70, eigener_weg: 55 }, reason: 'Belastbar bleiben, wenn es darauf ankommt.' },
      { id: 'black_edition', label: 'Black Edition', patterns: ['black edition'], weights: { dunkel: 90, leise_klar: 65, standfest: 50 }, reason: 'Dunkel, reduziert, klare Haltung.' },
      { id: 'siegen', label: 'Siegen kommt vom Kämpfen', patterns: ['siegen kommt vom kämpfen', 'siegen kommt vom kaempfen'], weights: { standfest: 100, dranbleiben: 85, dunkel: 45 }, reason: 'Rückschlag, wieder aufstehen, nächster Versuch.' },
      { id: 'rueckgrat', label: 'Rückgrat', patterns: ['rückgrat', 'rueckgrat'], weights: { standfest: 100, leise_klar: 65, crew: 25 }, reason: 'Klare Haltung. Mehr braucht es manchmal nicht.' },
      { id: 'boxing_angel', label: 'Boxing Angel', patterns: ['boxing angel'], weights: { eigener_weg: 90, leise_klar: 65, technik: 40 }, reason: 'Stärke muss nicht laut sein. Der Kontrast macht die Aussage.' },
      { id: 'berserker', label: 'Berserker', patterns: ['berserker'], weights: { dunkel: 100, standfest: 85, technik: 35 }, reason: 'Mehr Intensität, mehr Kante. Aber nicht ohne Kontrolle.' },
      { id: 'panther', label: 'Panther', patterns: ['panther'], weights: { technik: 100, ring_stil: 60, leise_klar: 50 }, reason: 'Geduld, Timing, Präzision. Nicht bloß Lautstärke.' },
      { id: 'ring_ruler', label: 'Ring Ruler', patterns: ['ring ruler'], weights: { ring_stil: 100, dunkel: 65, standfest: 45 }, reason: 'Ringkultur mit Präsenz und sichtbarer Kante.' },
      { id: 'skull', label: 'Skull', patterns: ['skull'], weights: { dunkel: 100, eigener_weg: 35, leise_klar: 25 }, reason: 'Dunkler, direkter, eine Spur kompromissloser.' },
      { id: 'sometimes_princess', label: 'Sometimes Princess', patterns: ['sometimes princess', 'sometime princess'], weights: { eigener_weg: 100, ring_stil: 60, leise_klar: 45 }, reason: 'Eigener Stil. Keine feste Rolle, keine Erklärung nötig.' },
      { id: 'fight_soul', label: 'Fight for Your Soul', patterns: ['fight for your soul'], weights: { eigener_weg: 100, standfest: 75, leise_klar: 35 }, reason: 'Bei sich bleiben, wenn es persönlich wird.' },
      { id: 'boxing_mind', label: 'Boxing Mind', patterns: ['boxing mind'], weights: { technik: 95, eigener_weg: 80, standfest: 60 }, reason: 'Klarer Kopf, Geduld, Entscheidung unter Druck.' },
      { id: 'kaempferin', label: 'Kämpferin', patterns: ['kämpferin', 'kaempferin'], weights: { eigener_weg: 100, standfest: 65, ring_stil: 50 }, reason: 'Selbstbestimmt, direkt, ohne sich in eine Rolle stecken zu lassen.' },
      { id: 'keine_grenzen', label: 'Keine Grenzen', patterns: ['keine grenzen'], weights: { dranbleiben: 85, eigener_weg: 75, standfest: 55, alte_schule: 25 }, reason: 'Den eigenen Rahmen weiter setzen, statt zu früh stehenzubleiben.' },
      { id: 'faustkampf', label: 'Faustkampf', patterns: ['faustkampf'], weights: { alte_schule: 100, technik: 75, leise_klar: 45 }, reason: 'Boxsport auf das Wesentliche runtergebrochen: Handwerk und Haltung.' },
      { id: 'kein_rueckzug', label: 'Kein Rückzug', patterns: ['kein rückzug', 'kein rueckzug'], weights: { standfest: 100, dunkel: 65, eigener_weg: 50, alte_schule: 30 }, reason: 'Nicht ausweichen. Neu ansetzen. Linie halten.' },
      { id: 'tu_es_fuer_dich', label: 'Tu es für dich', patterns: ['tu es für dich', 'tu es fuer dich'], weights: { eigener_weg: 100, dranbleiben: 60, leise_klar: 55 }, reason: 'Kein Publikum nötig. Der eigene Grund reicht.' },
      { id: 'train_harder', label: 'Train Harder', patterns: ['train harder'], weights: { dranbleiben: 100, technik: 50, leise_klar: 25 }, reason: 'Training, Arbeit, wiederholen. Besser werden.' },
      { id: 'herz_boxen', label: 'Mein Herz schlägt fürs Boxen', patterns: ['mein herz schlägt fürs boxen', 'mein herz schlaegt fürs boxen', 'mein herz schlaegt fuers boxen'], weights: { ring_stil: 95, dranbleiben: 55, eigener_weg: 45 }, reason: 'Boxen nicht nur als Training. Sondern als Teil von dir.' },
      { id: 'eat_sleep_repeat', label: 'Eat Sleep Repeat', patterns: ['eat sleep repeat'], weights: { dranbleiben: 100, ring_stil: 55, leise_klar: 25 }, reason: 'Routine, Training, Wiederholung. Ohne große Erklärung.' },
      { id: 'aufgeben', label: 'Aufgeben ist keine Option', patterns: ['aufgeben ist keine option'], weights: { standfest: 95, dranbleiben: 85, dunkel: 35 }, reason: 'Wenn Weitergehen mehr zählt als ein glatter Weg.' },
      { id: 'erfolg_fleiss', label: 'Erfolg durch Fleiß', patterns: ['erfolg durch fleiß', 'erfolg durch fleiss'], weights: { dranbleiben: 100, technik: 60, standfest: 45 }, reason: 'Arbeit, Wiederholung, Disziplin. Kein Geheimnis.' },
      { id: 'boxing_dream', label: 'Boxing Dream', patterns: ['boxing dream'], weights: { ring_stil: 95, dranbleiben: 60, eigener_weg: 45 }, reason: 'Ziel vor Augen, Boxkultur im Blick, etwas mehr Style.' },
      { id: 'boxing_strength', label: 'Boxing Strength', patterns: ['boxing strength'], weights: { technik: 80, standfest: 75, ring_stil: 55, leise_klar: 35 }, reason: 'Stärke aus Stand, Kontrolle und Technik. Nicht aus Show.' },
      { id: 'king_ring', label: 'King of the Ring', patterns: ['king of the ring'], weights: { ring_stil: 100, standfest: 55, dunkel: 45 }, reason: 'Klassische Ringidentität. Sichtbar, aber nicht beliebig.' },
      { id: 'niederlagen', label: 'Niederlagen', patterns: ['niederlagen'], weights: { standfest: 90, technik: 65, leise_klar: 60 }, reason: 'Fehler annehmen. Sortieren. Weiterarbeiten.' },
      { id: 'pugilist', label: 'Pugilist', patterns: ['pugilist'], weights: { technik: 100, alte_schule: 95, leise_klar: 55 }, reason: 'Boxen als Handwerk: Technik, Kontrolle, Respekt.' },
      { id: 'king_boxer_2', label: 'King Boxer 2', patterns: ['king boxer 2'], weights: { alte_schule: 85, standfest: 65, ring_stil: 65 }, reason: 'Klassischer Boxercharakter mit klarer Ringidentität.' },
      { id: 'fitnessboxer', label: 'Fitnessboxer', patterns: ['fitnessboxer'], weights: { dranbleiben: 80, technik: 55, ring_stil: 40 }, reason: 'Training und Boxen ohne Wettkampfzwang.' },
      { id: 'freizeitsportler', label: 'Freizeitsportler', patterns: ['freizeitsportler'], weights: { dranbleiben: 70, eigener_weg: 55, ring_stil: 35 }, reason: 'Boxsport aus eigenem Antrieb. Mehr muss es nicht sein.' },
      { id: 'boxing_crew', label: 'Boxing Crew', patterns: ['boxing crew'], weights: { crew: 100, dranbleiben: 55, leise_klar: 30 }, reason: 'Gemeinsame Runden, Verlässlichkeit, die Menschen neben dir.' },
      { id: 'wind_weiter', label: 'Wind & Weiter', patterns: ['wind & weiter', 'wind und weiter'], weights: { wind_weite: 100, dranbleiben: 75, standfest: 45 }, reason: 'Wind, Gegenwind, nächster Schritt. Norddeutsch, ohne großes Gerede.' },
      { id: 'herb_weit_frei', label: 'Herb. Weit. Frei.', patterns: ['herb. weit. frei', 'herb weit frei'], weights: { wind_weite: 100, leise_klar: 65, eigener_weg: 45 }, reason: 'Weite, Freiheit, wenig Show.' },
      { id: 'norden_vergisst', label: 'Der Norden vergisst nicht', patterns: ['der norden vergisst nicht'], weights: { wind_weite: 100, standfest: 50, leise_klar: 35 }, reason: 'Herkunft, Erinnerung, das, was bleibt.' },
      { id: 'foerde_nights', label: 'Förde Nights', patterns: ['förde nights', 'foerde nights'], weights: { wind_weite: 90, ring_stil: 90, leise_klar: 25 }, reason: 'Kiel und Förde treffen auf einen urbaneren Look.' },
      { id: 'stand', label: 'STAND.', patterns: ['stand.'], weights: { standfest: 90, wind_weite: 70, crew: 45, leise_klar: 35 }, reason: 'Herkunft und Haltung. Ohne künstliche Trennung.' },
      { id: 'tragwerk', label: 'TRAGWERK', patterns: ['tragwerk'], weights: { crew: 100, standfest: 60, leise_klar: 35 }, reason: 'Verlässlichkeit, Verantwortung, Menschen, die mittragen.' },
      { id: 'harbour_city', label: 'Harbour City Division', patterns: ['harbour city division', 'harbour city'], weights: { wind_weite: 75, ring_stil: 75, dunkel: 25 }, reason: 'Hafen, Stadt, norddeutsche Herkunft. Etwas urbaner, etwas kantiger.' }
    ].sort((a, b) => Math.max(...Object.values(b.weights)) - Math.max(...Object.values(a.weights)) || b.patterns[0].length - a.patterns[0].length);

    const normalize = (value = '') => value
      .toString()
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();

    const countOccurrences = (text, term) => {
      if (!text || !term) return 0;
      let count = 0;
      let position = 0;
      while ((position = text.indexOf(term, position)) !== -1) {
        count += 1;
        position += term.length;
      }
      return Math.min(count, 3);
    };

    const cloneScores = () => Object.fromEntries(Object.keys(FAMILY_LABELS).map((key) => [key, 0]));

    const addScores = (target, additions, factor = 1) => {
      Object.entries(additions || {}).forEach(([family, value]) => {
        if (family in target) target[family] += Number(value || 0) * factor;
      });
      return target;
    };

    const initializeJourney = (root) => {
      if (!root || root.dataset.kcInitialized === 'true') return;
      root.dataset.kcInitialized = 'true';

      const intro = root.querySelector('[data-kc-intro]');
      const content = root.querySelector('[data-kc-journey-content]');
      const startButton = root.querySelector('[data-kc-action="journey-start"]');
      const steps = Array.from(root.querySelectorAll('[data-kc-step]'));
      const navigation = root.querySelector('[data-kc-navigation]');
      const backButton = root.querySelector('[data-kc-back]');
      const nextButton = root.querySelector('[data-kc-next]');
      const progressText = root.querySelector('[data-kc-progress]');
      const progressBar = root.querySelector('[data-kc-progress-bar]');
      const liveRegion = root.querySelector('[data-kc-live]');
      const result = root.querySelector('[data-kc-result]');
      const resultTitle = root.querySelector('[data-kc-result-title]');
      const resultText = root.querySelector('[data-kc-result-text]');
      const profileTitle = root.querySelector('[data-kc-profile-title]');
      const productProfile = root.querySelector('[data-kc-product-profile]');
      const resultReason = root.querySelector('[data-kc-result-reason]');
      const recommendedProducts = root.querySelector('[data-kc-recommended-products]');
      const noProducts = root.querySelector('[data-kc-no-products]');
      const restartButton = root.querySelector('[data-kc-restart]');
      const includeSoldOut = root.dataset.includeSoldOut === 'true';

      if (!intro || !content || !startButton || !steps.length || !navigation || !backButton || !nextButton || !result) return;

      const allCandidates = Array.from(root.querySelectorAll('[data-kc-product-candidate]'));
      const productOverrides = Array.from(root.querySelectorAll('[data-kc-product-override]'));
      const familyRules = Array.from(root.querySelectorAll('[data-kc-family-rule]'));

      const overrideByProduct = new Map();
      productOverrides.forEach((node) => {
        overrideByProduct.set(node.dataset.productId, {
          enabled: node.dataset.enabled !== 'false',
          adjustment: Number(node.dataset.adjustment || 0),
          family: node.dataset.family || 'auto',
          familyStrength: Number(node.dataset.familyStrength || 0),
          reason: node.dataset.reason || ''
        });
      });

      const candidateByProduct = new Map();
      allCandidates.forEach((candidate) => {
        const productId = candidate.dataset.productId;
        if (!productId) return;
        const existing = candidateByProduct.get(productId);
        if (!existing || candidate.dataset.source === 'manual') candidateByProduct.set(productId, candidate);
      });
      const productCandidates = Array.from(candidateByProduct.values());

      const state = { currentStep: 0, answers: {} };

      const setLiveMessage = (message) => { if (liveRegion) liveRegion.textContent = message; };

      // V1.11: Bilder wechseln nicht mehr mit einzelnen Antworten.
      // Jede Station behält ihr eigenes Leitbild; die Antworten wirken über Text und Auswertung.
      const swapStepImage = () => {};
      const setStepStates = (activeIndex) => {
        steps.forEach((step, index) => {
          const field = step.dataset.field;
          const answered = Boolean(state.answers[field]);
          step.hidden = index > activeIndex;
          step.dataset.stepState = index < activeIndex ? 'complete' : index === activeIndex ? 'active' : 'upcoming';
          step.classList.toggle('is-answered', answered);
        });
      };
      const focusHeading = (container) => {
        const heading = container ? container.querySelector('[tabindex="-1"]') : null;
        if (heading) heading.focus({ preventScroll: true });
      };

      const updateProgress = (stepIndex, isResult = false) => {
        if (isResult) {
          if (progressText) progressText.textContent = 'Ergebnis';
          if (progressBar) progressBar.style.width = '100%';
          return;
        }
        const currentNumber = stepIndex + 1;
        const total = steps.length;
        if (progressText) progressText.textContent = `${String(currentNumber).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        if (progressBar) progressBar.style.width = `${(currentNumber / total) * 100}%`;
      };

      const showStep = (stepIndex, shouldFocus = true) => {
        state.currentStep = stepIndex;
        setStepStates(stepIndex);
        result.hidden = true;
        navigation.hidden = false;
        backButton.hidden = stepIndex === 0;

        const currentStep = steps[stepIndex];
        const field = currentStep.dataset.field;
        const hasAnswer = Boolean(state.answers[field]);
        const response = currentStep.querySelector('[data-kc-choice-response]');
        const nextLabels = ['Weiter zur Haltung →', 'Weiter zum Ausdruck →', 'Weiter in den Alltag →', 'Weiter zur Substanz →', 'Meine Auswahl ansehen'];

        nextButton.disabled = !hasAnswer;
        nextButton.textContent = nextLabels[stepIndex] || 'Weiter';
        nextButton.classList.toggle('is-final', stepIndex === steps.length - 1);
        if (response) {
          response.textContent = state.answers[field]?.response || '';
          response.hidden = !state.answers[field]?.response;
        }
        if (hasAnswer) swapStepImage(currentStep, field, state.answers[field].value);
        updateProgress(stepIndex);
        if (shouldFocus) {
          currentStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
          focusHeading(currentStep);
        }
      };

      const selectChoice = (button) => {
        const step = button.closest('[data-kc-step]');
        if (!step) return;
        const stepIndex = Number(step.dataset.stepIndex || 0);
        const field = step.dataset.field;
        const value = button.dataset.value;
        const label = button.dataset.label || button.textContent.trim();
        const responseText = button.dataset.response || '';
        const response = step.querySelector('[data-kc-choice-response]');

        step.querySelectorAll('[data-kc-choice]').forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
        state.answers[field] = { value, label, response: responseText };
        swapStepImage(step, field, value);
        if (response) {
          response.textContent = responseText;
          response.hidden = !responseText;
        }
        showStep(stepIndex, false);
        nextButton.disabled = false;
        setLiveMessage(`${label} ausgewählt.`);
      };

      const getJourneyFamilyScores = () => {
        const scores = cloneScores();
        const direction = state.answers.brand_direction?.value;
        const character = state.answers.character?.value;
        const expression = state.answers.design_expression?.value;

        const directionMap = {
          north: { wind_weite: 10, leise_klar: 1 },
          boxing: { technik: 5, dranbleiben: 4, standfest: 4, ring_stil: 4, alte_schule: 2 },
          both: { wind_weite: 5, standfest: 4, ring_stil: 4, technik: 3, crew: 1 },
          open: { eigener_weg: 4, ring_stil: 2, leise_klar: 3 }
        };
        const characterMap = {
          persist: { dranbleiben: 9, standfest: 5, wind_weite: 2 },
          calm: { technik: 8, leise_klar: 6, standfest: 2, alte_schule: 2 },
          edge: { standfest: 8, dunkel: 4, eigener_weg: 3, ring_stil: 2 },
          people: { crew: 10, standfest: 3, leise_klar: 2 }
        };
        const expressionMap = {
          sign: { leise_klar: 7, alte_schule: 2, technik: 2 },
          balanced: { leise_klar: 6, technik: 3, standfest: 2 },
          present: { ring_stil: 7, dunkel: 5, standfest: 2 },
          minimal: { leise_klar: 10, technik: 2, eigener_weg: 1 }
        };

        addScores(scores, directionMap[direction]);
        addScores(scores, characterMap[character]);
        addScores(scores, expressionMap[expression]);
        return scores;
      };

      const detectKnownDesign = (title, searchText) => {
        const normalizedTitle = normalize(title);
        const normalizedText = normalize(searchText);
        for (const design of KNOWN_DESIGNS) {
          const titleHit = design.patterns.some((pattern) => normalizedTitle.includes(normalize(pattern)));
          if (titleHit) return design;
        }
        for (const design of KNOWN_DESIGNS) {
          const textHit = design.patterns.some((pattern) => normalizedText.includes(normalize(pattern)));
          if (textHit) return design;
        }
        return null;
      };

      const inferUnknownDesignKey = (title) => normalize(title)
        .replace(/knockout collection/g, '')
        .replace(/t-?shirt|hoodie|zip hoodie|zoodie|tank top|oversized|heavy|ultra heavy|classic|creator|freestyler|women|woman|damen|herren|unisex/gi, '')
        .replace(/\b(schwarz|black|weiß|weiss|white|egret|natural raw|navy|grau|grey|gischt)\b/gi, '')
        .replace(/[^a-z0-9äöüß&. ]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim() || normalize(title);

      const scoreTextFamilies = (text) => {
        const scores = cloneScores();
        const normalizedText = normalize(text);
        Object.entries(FAMILY_KEYWORDS).forEach(([family, terms]) => {
          terms.strong.forEach((term) => { scores[family] += countOccurrences(normalizedText, normalize(term)) * 14; });
          terms.weak.forEach((term) => { scores[family] += countOccurrences(normalizedText, normalize(term)) * 4; });
        });
        return scores;
      };

      const applyFamilyRules = (candidate, scores) => {
        const haystack = normalize(`${candidate.dataset.productTitle || ''} ${candidate.dataset.searchText || ''}`);
        familyRules.forEach((rule) => {
          const match = normalize(rule.dataset.match || '');
          const family = rule.dataset.family;
          if (!match || !family || !haystack.includes(match) || !(family in scores)) return;
          const strength = Number(rule.dataset.strength || 0);
          if (rule.dataset.action === 'boost') scores[family] += strength;
          if (rule.dataset.action === 'suppress') scores[family] = Math.max(0, scores[family] - strength);
          if (rule.dataset.action === 'exclude_family') scores[family] = 0;
        });
      };

      const getProductSemantic = (candidate) => {
        const title = candidate.dataset.productTitle || '';
        const text = candidate.dataset.searchText || '';
        const known = detectKnownDesign(title, text);
        const scores = scoreTextFamilies(`${title} ${text}`);

        if (known) addScores(scores, known.weights, 1);

        const override = overrideByProduct.get(candidate.dataset.productId);
        if (override?.family && override.family !== 'auto' && override.family in scores) {
          scores[override.family] += Number(override.familyStrength || 0);
        }
        applyFamilyRules(candidate, scores);

        return {
          known,
          scores,
          designId: known?.id || inferUnknownDesignKey(title),
          designLabel: known?.label || inferUnknownDesignKey(title).replace(/\b\w/g, (char) => char.toUpperCase()),
          reason: override?.reason || known?.reason || ''
        };
      };

      const keywordHitScore = (text, groups) => groups.reduce((score, group) => {
        const hits = group.terms.some((term) => text.includes(term));
        return score + (hits ? group.score : 0);
      }, 0);

      const getProductFitScore = (candidate) => {
        const text = normalize(`${candidate.dataset.productTitle || ''} ${candidate.dataset.searchText || ''}`);
        const expression = state.answers.design_expression?.value;
        const useCase = state.answers.use_case?.value;
        const feel = state.answers.garment_feel?.value;
        let score = 0;
        const matches = [];

        const expressionRules = {
          sign: [
            { terms: ['klein', 'detail', 'zeichen', 'brust', 'frontprint', 'koordinaten'], score: 5 },
            { terms: ['reduziert', 'dezent', 'einseitig'], score: 3 }
          ],
          balanced: [
            { terms: ['klar', 'reduziert', 'einseitig', 'brust', 'front'], score: 4 },
            { terms: ['statement', 'sichtbar'], score: 2 }
          ],
          present: [
            { terms: ['groß', 'gross', 'rücken', 'ruecken', 'backprint', 'statement', 'präsent', 'praesent'], score: 6 },
            { terms: ['ring ruler', 'king of the ring', 'berserker', 'skull'], score: 3 }
          ],
          minimal: [
            { terms: ['minimal', 'reduziert', 'dezent', 'klein', 'ruhig', 'zurückhaltend', 'zurueckhaltend'], score: 7 },
            { terms: ['groß', 'gross', 'rückenprint', 'rueckenprint'], score: -2 }
          ]
        };

        const useRules = {
          everyday: [
            { terms: ['alltag', 'streetwear', 'freizeit', 'jeden tag', 'vielseitig'], score: 7 },
            { terms: ['t-shirt', 'shirt', 'hoodie'], score: 2 }
          ],
          training: [
            { terms: ['training', 'gym', 'halle', 'sport', 'workout', 'bewegung'], score: 8 },
            { terms: ['tank', 't-shirt', 'shirt'], score: 3 }
          ],
          outdoor: [
            { terms: ['draußen', 'draussen', 'wind', 'wetter', 'küste', 'kueste', 'outdoor'], score: 8 },
            { terms: ['hoodie', 'zip', 'warm', '480', '280'], score: 4 }
          ],
          versatile: [
            { terms: ['vielseitig', 'alltag', 'training', 'streetwear', 'freizeit'], score: 5 },
            { terms: ['t-shirt', 'hoodie', 'zip'], score: 2 }
          ]
        };

        const feelRules = {
          light: [
            { terms: ['tank', '180 g', '180g', 'leicht', 'classic', 'creator'], score: 11 },
            { terms: ['240 g', '240g', 'heavy', 'ultra heavy', '480 g', '480g', 'hoodie', 'zip hoodie', 'zoodie'], score: -16 }
          ],
          solid: [
            { terms: ['ultra heavy', '480 g', '480g'], score: 15 },
            { terms: ['heavy', '240 g', '240g', 'oversized', 'schwer', 'fest', 'substanziell'], score: 10 },
            { terms: ['180 g', '180g', 'leicht', 'tank', 'classic', 'creator'], score: -18 }
          ],
          warm: [
            { terms: ['ultra heavy', '480 g', '480g'], score: 15 },
            { terms: ['hoodie', 'zip hoodie', 'zoodie', '280 g', '280g', 'warm', 'fleece'], score: 11 },
            { terms: ['tank top', 'tank', 'classic t-shirt', 'creator t-shirt'], score: -18 }
          ],
          free: [
            { terms: ['tank', 'beweglich', 'bewegungsfreiheit', 'relaxed', 'locker'], score: 12 },
            { terms: ['oversized'], score: 4 },
            { terms: ['ultra heavy', '480 g', '480g'], score: -16 }
          ]
        };

        score += keywordHitScore(text, expressionRules[expression] || []);
        score += keywordHitScore(text, useRules[useCase] || []);
        score += keywordHitScore(text, feelRules[feel] || []);

        if (useCase === 'training' && /training|gym|halle|sport|tank/.test(text)) matches.push('use_training');
        if (useCase === 'outdoor' && /wind|wetter|draußen|draussen|hoodie|zip/.test(text)) matches.push('use_outdoor');
        if (useCase === 'everyday' && /alltag|streetwear|freizeit|t-shirt|hoodie/.test(text)) matches.push('use_everyday');
        if (useCase === 'versatile' && /alltag|streetwear|freizeit|t-shirt|hoodie|zip|training/.test(text)) matches.push('use_versatile');
        if (feel === 'solid' && /heavy|240 g|240g|oversized|schwer/.test(text)) matches.push('feel_solid');
        if (feel === 'warm' && /hoodie|zip|480 g|480g|280 g|280g|warm/.test(text)) matches.push('feel_warm');
        if (feel === 'light' && /180 g|180g|leicht|classic|tank/.test(text)) matches.push('feel_light');
        if (feel === 'free' && /tank|beweglich|relaxed|oversized|locker/.test(text)) matches.push('feel_free');

        return { score, matches };
      };

      const DESIGN_GROUPS = {
        north: new Set(['wind_weiter', 'herb_weit_frei', 'norden_vergisst', 'harbour_city']),
        bridge: new Set(['foerde_nights', 'stand']),
        crew: new Set(['boxing_crew', 'tragwerk', 'stand']),
        persist: new Set(['siegen', 'keine_grenzen', 'train_harder', 'eat_sleep_repeat', 'aufgeben', 'erfolg_fleiss', 'wind_weiter']),
        calm: new Set(['black_demut', 'panther', 'boxing_mind', 'faustkampf', 'pugilist', 'niederlagen', 'herb_weit_frei']),
        edge: new Set(['black_widerstand', 'black_unbeugsam', 'black_unzerbrechlich', 'rueckgrat', 'kein_rueckzug', 'stand', 'harbour_city', 'norden_vergisst']),
        loud: new Set(['berserker', 'skull', 'ring_ruler', 'king_ring']),
        quiet: new Set(['black_demut', 'rueckgrat', 'boxing_angel', 'panther', 'faustkampf', 'tu_es_fuer_dich', 'niederlagen', 'pugilist', 'herb_weit_frei', 'norden_vergisst', 'stand']),
        visible: new Set(['siegen', 'berserker', 'ring_ruler', 'skull', 'kaempferin', 'kein_rueckzug', 'aufgeben', 'boxing_dream', 'king_ring', 'king_boxer_2', 'wind_weiter', 'harbour_city'])
      };

      const PURE_BOX_DESIGNS = new Set(KNOWN_DESIGNS
        .map((design) => design.id)
        .filter((id) => !DESIGN_GROUPS.north.has(id) && !DESIGN_GROUPS.bridge.has(id) && id !== 'tragwerk'));

      const getDesignCompatibilityAdjustment = (semantic) => {
        const id = semantic.designId;
        if (!id) return 0;
        const direction = state.answers.brand_direction?.value;
        const character = state.answers.character?.value;
        const expression = state.answers.design_expression?.value;
        let adjustment = 0;

        // Richtung ist die stärkste Leitplanke: Nord, Box DNA oder bewusst die Brücke.
        if (direction === 'north') {
          if (DESIGN_GROUPS.north.has(id)) adjustment += 90;
          if (DESIGN_GROUPS.bridge.has(id)) adjustment += 45;
          if (PURE_BOX_DESIGNS.has(id)) adjustment -= 85;
        } else if (direction === 'boxing') {
          if (PURE_BOX_DESIGNS.has(id)) adjustment += 70;
          if (DESIGN_GROUPS.bridge.has(id)) adjustment += 30;
          if (DESIGN_GROUPS.north.has(id)) adjustment -= 85;
        } else if (direction === 'both') {
          if (DESIGN_GROUPS.bridge.has(id)) adjustment += 100;
          if (DESIGN_GROUPS.north.has(id) || PURE_BOX_DESIGNS.has(id)) adjustment += 25;
        }

        // Haltung verfeinert die Aussage, ohne die gewählte Markenwelt zu überschreiben.
        if (character === 'persist' && DESIGN_GROUPS.persist.has(id)) adjustment += 65;
        if (character === 'calm' && DESIGN_GROUPS.calm.has(id)) adjustment += 65;
        if (character === 'edge') {
          if (DESIGN_GROUPS.edge.has(id)) adjustment += 70;
          if (DESIGN_GROUPS.loud.has(id)) adjustment += 25;
        }
        if (character === 'people') {
          if (DESIGN_GROUPS.crew.has(id)) adjustment += 100;
          if (DESIGN_GROUPS.loud.has(id)) adjustment -= 70;
        }

        // Ausdruck trennt „klare Aussage“ von „lautem Motiv“.
        if (expression === 'sign') {
          if (DESIGN_GROUPS.quiet.has(id)) adjustment += 65;
          if (DESIGN_GROUPS.loud.has(id)) adjustment -= 100;
        } else if (expression === 'balanced') {
          if (DESIGN_GROUPS.quiet.has(id)) adjustment += 50;
          if (DESIGN_GROUPS.loud.has(id)) adjustment -= 90;
        } else if (expression === 'present') {
          if (DESIGN_GROUPS.visible.has(id)) adjustment += 70;
          if (DESIGN_GROUPS.loud.has(id)) adjustment += 40;
        } else if (expression === 'minimal') {
          if (DESIGN_GROUPS.quiet.has(id)) adjustment += 90;
          if (DESIGN_GROUPS.loud.has(id)) adjustment -= 130;
          if (DESIGN_GROUPS.visible.has(id)) adjustment -= 35;
        }

        return adjustment;
      };

      const getSemanticAlignment = (journeyScores, productScores) => Object.keys(FAMILY_LABELS).reduce((total, family) => {
        return total + (journeyScores[family] || 0) * (productScores[family] || 0) / 10;
      }, 0);

      const getTopFamilies = (scores, count = 3) => Object.entries(scores)
        .sort((a, b) => b[1] - a[1])
        .filter(([, value]) => value > 0)
        .slice(0, count)
        .map(([key, value]) => ({ key, value, label: FAMILY_LABELS[key] }));

      const rankCandidates = () => {
        const journeyScores = getJourneyFamilyScores();
        const ranked = [];
        const seenProductIds = new Set();

        productCandidates.forEach((candidate, index) => {
          const productId = candidate.dataset.productId || '';
          if (productId && seenProductIds.has(productId)) return;
          if (productId) seenProductIds.add(productId);
          if (!includeSoldOut && candidate.dataset.available !== 'true') return;
          const override = overrideByProduct.get(candidate.dataset.productId);
          if (override && !override.enabled) return;

          const semantic = getProductSemantic(candidate);
          const fit = getProductFitScore(candidate);
          const semanticScore = getSemanticAlignment(journeyScores, semantic.scores);
          const manualAdjustment = Number(override?.adjustment || 0);
          const compatibilityAdjustment = getDesignCompatibilityAdjustment(semantic);
          const total = semanticScore * 4 + fit.score * 6 + manualAdjustment + compatibilityAdjustment;

          ranked.push({ candidate, semantic, fit, semanticScore, total, index, journeyScores, compatibilityAdjustment });
        });

        return ranked.sort((a, b) => b.total - a.total || b.semanticScore - a.semanticScore || a.index - b.index);
      };

      const hasStrongGarmentConflict = (entry) => {
        const feel = state.answers.garment_feel?.value;
        const title = normalize(entry.candidate.dataset.productTitle || '');
        if (!feel || !title) return false;

        const isTank = /tank top|tank/.test(title);
        const isTshirt = /t-?shirt|classic|creator/.test(title);
        const isHoodie = /hoodie|zip hoodie|zoodie/.test(title);
        const isHeavy = /ultra heavy|heavy|480 g|480g|240 g|240g|oversized/.test(title);

        if (feel === 'light' && (isHoodie || isHeavy)) return true;
        if (feel === 'solid' && (isTank || (isTshirt && !isHeavy))) return true;
        if (feel === 'warm' && (isTank || (isTshirt && !isHeavy))) return true;
        if (feel === 'free' && /ultra heavy|480 g|480g/.test(title)) return true;
        return false;
      };

      const selectDesignPool = (ranked) => {
        const bestByDesign = new Map();
        ranked.forEach((entry) => {
          const current = bestByDesign.get(entry.semantic.designId);
          if (!current || entry.total > current.total) bestByDesign.set(entry.semantic.designId, entry);
        });

        const designs = Array.from(bestByDesign.values()).sort((a, b) => b.total - a.total);
        if (!designs.length) return [];

        // Tragegefühl ist die letzte konkrete Produktentscheidung. Grobe Widersprüche
        // (z. B. Tank Top bei "schwer und fest") werden nicht durch ein starkes Designscore überstimmt.
        const garmentCompatible = designs.filter((entry) => !hasStrongGarmentConflict(entry));
        let pool = garmentCompatible.length >= 2 ? garmentCompatible : designs;

        // Eine klar gewählte Markenwelt bleibt auch im Ergebnis sichtbar. Wenn genügend passende
        // Designs vorhanden sind, wird keine fremde Welt nur zum Auffüllen der dritten Karte erzwungen.
        const direction = state.answers.brand_direction?.value;
        if (direction === 'north') {
          const preferred = pool.filter((entry) => DESIGN_GROUPS.north.has(entry.semantic.designId) || DESIGN_GROUPS.bridge.has(entry.semantic.designId));
          if (preferred.length >= 2) pool = preferred;
        } else if (direction === 'boxing') {
          const preferred = pool.filter((entry) => PURE_BOX_DESIGNS.has(entry.semantic.designId) || DESIGN_GROUPS.bridge.has(entry.semantic.designId));
          if (preferred.length >= 2) pool = preferred;
        }

        const bestScore = pool[0]?.total ?? designs[0].total;
        const selected = pool.filter((entry, index) => {
          if (index === 0) return true;
          // Keine künstliche Vielfalt: Nur Lösungen zeigen, die tatsächlich nah an der besten liegen.
          return entry.total >= bestScore * 0.72;
        });

        return selected.slice(0, 3);
      };

      const buildDesignReason = (entry) => {
        if (entry.semantic.reason) return entry.semantic.reason;
        const journey = getJourneyFamilyScores();
        const shared = getTopFamilies(entry.semantic.scores, 5)
          .filter((family) => (journey[family.key] || 0) > 0)
          .sort((a, b) => (journey[b.key] || 0) * b.value - (journey[a.key] || 0) * a.value)
          .slice(0, 2);
        if (shared.length) return `Passt zu ${shared.map((item) => item.label).join(' und ')}.`;
        return 'Die Aussage liegt nah an dem, was du gewählt hast.';
      };

      const buildMatchText = (entry) => {
        const matches = new Set(entry.fit.matches);
        const usePhrases = {
          use_training: 'beim Training',
          use_outdoor: 'draußen',
          use_everyday: 'im Alltag',
          use_versatile: 'an vielen Stellen deines Alltags'
        };
        const feelSentences = {
          feel_solid: 'Du willst Gewicht, Griff und spürbare Substanz.',
          feel_warm: 'Du willst Wärme und Schutz.',
          feel_light: 'Du willst es leicht und unkompliziert.',
          feel_free: 'Du willst Bewegungsfreiheit.'
        };
        const useKey = Array.from(matches).find((key) => usePhrases[key]);
        const feelKey = Array.from(matches).find((key) => feelSentences[key]);

        if (useKey && feelKey) {
          return `Du willst es ${usePhrases[useKey]} tragen. ${feelSentences[feelKey]} Dieses Teil passt gut dazu.`;
        }
        if (useKey) return `Du willst es ${usePhrases[useKey]} tragen. Dafür passt dieses Teil gut.`;
        if (feelKey) return `${feelSentences[feelKey]} Dieses Teil passt gut dazu.`;
        return 'Die Aussage passt zu deiner Auswahl. Beim Tragegefühl bleibt dieses Teil bewusst eine Alternative.';
      };

      const renderRecommendedProducts = () => {
        if (!recommendedProducts || !noProducts) return [];
        recommendedProducts.replaceChildren();
        const selected = selectDesignPool(rankCandidates());
        noProducts.hidden = selected.length > 0;

        selected.forEach((entry, index) => {
          const sourceCard = entry.candidate.querySelector('[data-kc-product-card]');
          const card = sourceCard?.cloneNode(true);
          if (!card) return;

          const badge = card.querySelector('[data-kc-product-badge]');
          const designName = card.querySelector('[data-kc-design-name]');
          const designReason = card.querySelector('[data-kc-design-reason]');
          const match = card.querySelector('[data-kc-product-match]');

          if (badge) badge.textContent = index === 0 ? 'Passt am stärksten' : 'Passt ebenfalls';
          if (designName) designName.textContent = entry.semantic.designLabel;
          if (designReason) designReason.textContent = buildDesignReason(entry);
          if (match) match.textContent = buildMatchText(entry);
          recommendedProducts.appendChild(card);
        });

        return selected;
      };

      const renderResult = () => {
        const journeyScores = getJourneyFamilyScores();
        const topFamilies = getTopFamilies(journeyScores, 3);
        setStepStates(steps.length - 1);
        steps.forEach((step) => { step.dataset.stepState = 'complete'; });
        navigation.hidden = true;
        result.hidden = false;
        updateProgress(steps.length - 1, true);

        const first = topFamilies[0];
        const second = topFamilies[1];
        if (resultTitle) {
          resultTitle.textContent = first && second
            ? `${first.label} · ${second.label}`
            : `${first?.label || 'Offene Richtung'}`;
        }
        if (resultText) {
          resultText.textContent = first
            ? `${FAMILY_REASON[first.key]} ${second ? FAMILY_REASON[second.key] : ''}`
            : 'Deine Auswahl bleibt bewusst offen. Deshalb zeigen wir dir unterschiedliche Richtungen statt einer erzwungenen Einzellösung.';
        }

        root.querySelectorAll('[data-kc-summary]').forEach((summary) => {
          const field = summary.dataset.kcSummary;
          summary.textContent = state.answers[field]?.label || '—';
        });

        if (profileTitle) profileTitle.textContent = 'Darum zeigen wir dir diese Teile.';
        if (productProfile) productProfile.textContent = 'Die ersten drei Entscheidungen geben die Richtung vor. Alltag und Tragegefühl entscheiden danach, welche konkreten Teile dazu passen.';
        if (resultReason) resultReason.textContent = 'Wenn zwei Richtungen nah beieinanderliegen, zeigen wir lieber zwei ehrliche Möglichkeiten als eine künstlich eindeutige Antwort.';

        renderRecommendedProducts();
        setLiveMessage('Deine Auswahl ist bereit.');
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
        focusHeading(result);
      };

      const resetJourney = () => {
        state.currentStep = 0;
        state.answers = {};
        root.querySelectorAll('[data-kc-choice]').forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
        root.querySelectorAll('[data-kc-choice-response]').forEach((response) => { response.textContent = ''; response.hidden = true; });
        if (recommendedProducts) recommendedProducts.replaceChildren();
        if (noProducts) noProducts.hidden = true;
        result.hidden = true;
        showStep(0, false);
        setLiveMessage('Die Reise wurde neu gestartet.');
        content.scrollIntoView({ behavior: 'smooth', block: 'start' });
        focusHeading(steps[0]);
      };

      startButton.addEventListener('click', () => {
        content.hidden = false;
        startButton.setAttribute('aria-expanded', 'true');
        root.classList.add('kc-markenreise--started');
        showStep(0, false);
        content.scrollIntoView({ behavior: 'smooth', block: 'start' });
        focusHeading(steps[0]);
      });

      root.querySelectorAll('[data-kc-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => selectChoice(button));
      });

      nextButton.addEventListener('click', () => {
        const currentStep = steps[state.currentStep];
        const field = currentStep.dataset.field;
        if (!state.answers[field]) return;
        if (state.currentStep === steps.length - 1) return renderResult();
        showStep(state.currentStep + 1);
      });

      backButton.addEventListener('click', () => { if (state.currentStep > 0) showStep(state.currentStep - 1); });
      if (restartButton) restartButton.addEventListener('click', resetJourney);
    };

    const initializeAllJourneys = () => document.querySelectorAll('[data-kc-journey]').forEach(initializeJourney);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAllJourneys);
    else initializeAllJourneys();
    document.addEventListener('shopify:section:load', (event) => initializeJourney(event.target.querySelector('[data-kc-journey]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
